<template>
  <div v-if="interests">
    <popup-add-interest ref="popupAddInterest" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Interests</h3>
        <p class="mt-5">
          interests are key value tags that can be added to a user through a
          form and later used for segmentation such as: "Favorite drink: Dark
          and stormy"
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="$refs.popupAddInterest.show()"
            v-if="hasPermission('vp.crm.guestprofiles.edit')"
            type="relief"
            vslor="primary"
            >Add interest</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        max-items="50"
        pagination
        search
        :data="interests"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Interest</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  <vs-row>
                    <feather-icon
                      :icon="tr.icon"
                      svgClasses="h-5 w-5 stroke-current"
                    />
                    <span class="ml-3">{{ tr.name }}</span>
                  </vs-row>
                </p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="TrashIcon"
                  v-if="hasPermission('vp.crm.guestprofiles.edit')"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="confirmDelete(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import PopupAddInterest from "./PopupAddInterest.vue";
import { ClientSideRowModelSteps } from "ag-grid-community";

export default {
  components: { PopupAddInterest },
  data() {
    return {
      moment,
      itemToDelete: "",
    };
  },
  methods: {
    confirmDelete(item) {
      this.itemToDelete = item;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this item?",
        accept: this.deleteItem,
      });
    },
    async deleteItem() {
      await this.$store.dispatch(
        "guestSegmentation/deleteInterest",
        this.itemToDelete.name
      );
    },
  },
  computed: {
    ...mapGetters({
      interests: "guestSegmentation/interests",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("guestSegmentation/get");
    this.$vs.loading.close();
  },
};
</script>
